const runRecaptchaAndSubmit = (form) => {
    const recaptchaEl = form.querySelector('.g-recaptcha');
    var hasRecaptcha = "grecaptcha" in window && "RECAPTCHA_SITE_KEY" in window && recaptchaEl;
    if (hasRecaptcha) {
        grecaptcha.execute(window.RECAPTCHA_SITE_KEY, {}).then(function(token) {
            recaptchaEl.value = token;
            form.submit();
        });
    } else {
        form.submit();
    }
}

export default runRecaptchaAndSubmit;
